import { Box, InputAdornment, TextField, useTheme } from "@mui/material";
import Iconify from "~src/components/Iconify";
import { useState } from "react";

export const ProductRankingSelector = ({
  value,
  onSelect,
}: {
  value?: string;
  onSelect: (value?: string) => void;
}) => {
  const theme = useTheme();
  const [minPrice, setMinPrice] = useState(value ? value.split("__")[0] : "");
  const [maxPrice, setMaxPrice] = useState(value ? value.split("__")[1] : "");

  // Handle change for the minimum price input
  const handleMinPriceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newMinPrice = event.target.value;
    setMinPrice(newMinPrice);
    
    // Ensure the value is a valid number before sending it to the API
    const validMinPrice = newMinPrice === "" || isNaN(Number(newMinPrice)) ? "0" : newMinPrice;
    const validMaxPrice = maxPrice === "" || isNaN(Number(maxPrice)) ? "1000000" : maxPrice;
    onSelect(`${validMinPrice}__${validMaxPrice}`);
  };

  // Handle change for the maximum price input
  const handleMaxPriceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newMaxPrice = event.target.value;
    setMaxPrice(newMaxPrice);
    
    // Ensure the value is a valid number before sending it to the API
    const validMinPrice = minPrice === "" || isNaN(Number(minPrice)) ? "0" : minPrice;
    const validMaxPrice = newMaxPrice === "" || isNaN(Number(newMaxPrice)) ? "1000000" : newMaxPrice;
    onSelect(`${validMinPrice}__${validMaxPrice}`);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2
        }}>
        <Iconify icon={"solar:cup-star-linear"} width={25} height={25} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2
          }}>
          <TextField
            label="Min"
            variant="outlined"
            value={minPrice}
            onChange={handleMinPriceChange}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">Min :</InputAdornment>
                ),
              }
            }}
          />
          <TextField
            label="Max"
            variant="outlined"
            value={maxPrice}
            onChange={handleMaxPriceChange}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ color: theme.palette.grey[200] }}
                  >
                    Max :
                  </InputAdornment>
                ),
              }
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
